export enum DASHBOARDTYPE {
  SERVICE = 'service',
  METRIC = 'metric',
  DATABASE = 'database',
  BROWSER = 'browser'
}
export enum QueryTypes {
  ReadMetricsValue = 'readMetricsValue',
  ReadMetricsValues = 'readMetricsValues',
  SortMetrics = 'sortMetrics',
  ReadLabeledMetricsValues = 'readLabeledMetricsValues',
  READHEATMAP = 'readHeatMap',
  ReadSampledRecords = 'readSampledRecords',
  ReadMetricsTotalValue = 'readMetricsTotalValue',
  ReadCustomMetricsValues = 'readCustomMetricsValues',
  ReadMobileCustomMetricsValues = 'readMobileCustomMetricsValues', //'crashByFilter',
  ReadMobileCustomMetricsValue = 'performanceByFilter',
  GetGraphDataValuesPulse = 'getGraphDataPulse',
  ReadAndAggregateMetricsFilteredAtServiceScope = 'readAndAggregateMetricsFilteredAtServiceScope'
}
export const COMPARED = 'compared';
